import { resources } from "../resource";
import Header from "./headerPhase2";
import { Helmet } from "react-helmet";
import { Carousel } from "antd";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import { Button, FormHelperText } from "@material-ui/core";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../state";

const AiScribeConsent = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const clinicUrl = useSelector((state) => state.auth.clinicUrl);
  const _resources = resources[props.language];

  const patientForm = useSelector((state) => state.patientForm);
  const [formData, updateFormData] = useState(patientForm.patientForm);
  const dispatch = useDispatch();
  const actions = bindActionCreators(actionCreators, dispatch);
  const [selectedValue, setSelectedValue] = useState(null);
  const [showError, setShowError] = useState(false);
  
  useEffect(() => {

    if (location?.state == null) {
      if (clinicUrl && clinicUrl != "") {
        window.location.replace(clinicUrl);
      }
    }
    window.history.replaceState(null, "");
  }, []);

  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
    setShowError(false);
    updateFormData({
      ...formData,
      consentedToAI: event.target.value == "true" ? true : false,
    });
    actions.uploadPatientForm({
      ...formData,
      consentedToAI: event.target.value == "true" ? true : false,
    });
  };

  const nextButton = () => {
    if (!selectedValue) {
      setShowError(true);
      return;
    }
    
    navigate("/patient-checkin/signature", {
    state: { fromFlow: true, fromReview: true },
    });
  };

  const content =
    props.language == "en"
      ? enContent
      : props.language == "spa"
        ? spaContent
        : props.language == "cr"
          ? crContent
          : enContent;

  return (
    <>
      <Helmet>
        <title>CORA Health | AI Scribing Consent</title>
      </Helmet>
      <Header />

      <div className="content-wrapper-row row no-gutters form-review-carousel ">
        <div className="col-lg-7 form-review-container">
          <div className="p-4" dangerouslySetInnerHTML={{ __html: content }} />
          <div className="d-flex justify-content-center p-4">
            <FormControl
              className="bg-transparent px-2"
              error={showError}
              component="fieldset"
            >
              <RadioGroup
                row
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                value={selectedValue}
                onChange={handleRadioChange}
                className="gap-4"
              >
                <FormControlLabel
                  value="true"
                  control={<Radio />}
                  label="Consent"
                />
                <FormControlLabel
                  value="false"
                  control={<Radio />}
                  label="Non-Consent"
                />
              </RadioGroup>
              {showError && (
                <FormHelperText className="text-danger">
                  Please select any of these options
                </FormHelperText>
              )}
            </FormControl>
          </div>
          <Button
            className="dual-book-button next-btn"
            onClick={() => nextButton()}
            variant="contained"
            color="primary"
            type="submit"
            size="large"
          >
            {_resources.ReviewPage.NEXT}
          </Button>
          <Button
            size="large"
            id="back-btn"
            onClick={() => {
              navigate("/patient-checkin/review-form", {
                state: { fromReview: true },
              });
            }}
            className="dual-book-button back-button"
            variant="contained"
          >
            {_resources.ReviewPage.BACK}
          </Button>
        </div>
        <div className="col-lg-5  carousel-column">{renderCarousel()}</div>
      </div>
    </>
  );
};

export default AiScribeConsent;

const renderCarousel = () => (
  <Carousel initialSlide={Math.floor(Math.random() * 4)}>
    {[
      "clinic-pic-one",
      "clinic-pic-two",
      "clinic-pic-three",
      "clinic-pic-four",
    ].map((pic, index) => (
      <div key={index}>
        <div className={pic}></div>
      </div>
    ))}
  </Carousel>
);

const enContent = `
    <div>
      <h4>Patient Consent Form for AI Scribe Software</h3>
      
      <h4>Introduction</h4>
      <p>At CORA Physical Therapy, we are committed to providing high-quality care. To enhance our documentation process, we use AI scribe software to assist in creating accurate and efficient medical records.</p>
      
      <h4>Purpose of AI Scribe Software</h4>
      <p>The AI scribe software converts spoken words into text to document medical information accurately and efficiently. This technology helps in transcribing medical notes, reports, and other relevant documents during your therapy sessions.</p>
      
      <h4>How AI Scribe Software Works</h4>
      <p>During your therapy sessions, verbal information provided by you or your therapist may be recorded and transcribed by the AI scribe software. The AI system processes and converts spoken words into text, contributing to your medical records. Please note that the AI scribe will not make any decisions about your care; your therapist will review all notes before making any decisions.</p>
      
      <h4>Security Measures</h4>
      <p>We employ robust security measures to protect the confidentiality and integrity of the information processed through the AI scribe software. These measures include encryption, access controls, and regular security audits to prevent unauthorized access and protect against data breaches.</p>
      
      <h4>Patient Rights</h4>
      <p>All rights under our HIPAA notice apply to AI scribe.</p>
      
      <h4>Benefits and Risks of Using AI Scribe Software</h4>
      <h4>Benefits</h4>
      <ul>
        <li>Increased efficiency in medical record documentation</li>
        <li>Enhanced accuracy in transcribing verbal information</li>
      </ul>
      <h4>Risks</h4>
      <ul>
        <li>Possibility of errors in transcription</li>
        <li>Potential limitations in recognizing certain accents or speech patterns</li>
      </ul>
      
      <h4>Patient Consent</h4>
      <p>I have read and understand the information provided in this consent form. I have had the opportunity to ask questions which have been addressed to my satisfaction. By signing below, I voluntarily consent to the use of AI scribe software in the creation of my medical records at CORA Physical Therapy.</p>
    </div>
  `;
const spaContent = `
    <div>
      <h4>Formulario de Consentimiento del Paciente para el Software de Transcripción por IA</h4>
      
      <h4>Introducción</h4>
      <p>En CORA Physical Therapy, estamos comprometidos a proporcionar atención de alta calidad. Para mejorar nuestro proceso de documentación, utilizamos software de transcripción por IA para ayudar a crear registros médicos precisos y eficientes.</p>
      
      <h4>Propósito del Software de Transcripción por IA</h4>
      <p>El software de transcripción por IA convierte las palabras habladas en texto para documentar la información médica de manera precisa y eficiente. Esta tecnología ayuda a transcribir notas médicas, informes y otros documentos relevantes durante sus sesiones de terapia.</p>
      
      <h4>Cómo Funciona el Software de Transcripción por IA</h4>
      <p>Durante sus sesiones de terapia, la información verbal proporcionada por usted o su terapeuta puede ser grabada y transcrita por el software de transcripción por IA. El sistema de IA procesa y convierte las palabras habladas en texto, contribuyendo a sus registros médicos. Tenga en cuenta que el transcriptor de IA no tomará decisiones sobre su atención; su terapeuta revisará todas las notas antes de tomar cualquier decisión.</p>
      
      <h4>Medidas de Seguridad</h4>
      <p>Empleamos medidas de seguridad robustas para proteger la confidencialidad e integridad de la información procesada a través del software de transcripción por IA. Estas medidas incluyen cifrado, controles de acceso y auditorías de seguridad regulares para prevenir el acceso no autorizado y proteger contra violaciones de datos.</p>
      
      <h4>Derechos del Paciente</h4>
      <p>Todos los derechos bajo nuestro aviso de HIPAA se aplican al transcriptor de IA.</p>
      
      <h4>Beneficios y Riesgos del uso del Software de Transcripción por IA</h4>
      <h4>Beneficios</h4>
      <ul>
        <li>Mayor eficiencia en la documentación de registros médicos</li>
        <li>Mayor precisión en la transcripción de información verbal</li>
      </ul>
      <h4>Riesgos</h4>
      <ul>
        <li>Posibilidad de errores en la transcripción</li>
        <li>Limitaciones potenciales en el reconocimiento de ciertos acentos o patrones de habla</li>
      </ul>
      
      <h4>Consentimiento del Paciente</h4>
      <p>He leído y entiendo la información proporcionada en este formulario de consentimiento. He tenido la oportunidad de hacer preguntas que han sido respondidas a mi satisfacción. Al firmar a continuación, doy mi consentimiento voluntario para el uso del software de transcripción por IA en la creación de mis registros médicos en CORA Physical Therapy.</p>
    </div>
  `;
const crContent = `<div>
  <h4>Fòm Konsantman Pasyan pou Lojisyèl AI Scribe</h4>
  
  <h4>Entwodiksyon</h4>
  <p>Nan CORA Physical Therapy (Terapi Fizik CORA), nou angaje nou pou nou bay swen kalite siperyè. Pou amelyore pwosesis dokimantasyon nou an, nou itilize lojisyèl AI Scribe (Entèlijans Atifisyèl) pou ede nou kreye dosye medikal ki egzat e efikas.</p>
  
  <h4>Objektif Lojisyèl AI Scribe la</h4>
  <p>Lojisyèl ekri ak AI scribe la konvèti mo ki pale an tèks pou dokimante enfòmasyon medikal avèk presizyon ak efikasite. Teknoloji sa a ede nan transkri nòt, rapò ak lòt dokiman medikal enpòtan pandan sesyon terapi ou yo.</p>
  
  <h4>Kijan Lojisyèl AI Scribe Fonksyone</h4>
  <p>Pandan sesyon terapi ou yo, enfòmasyon vèbal ou bay oswa terapet ou a bay yo ka anrejistre epi transkri pa lojisyèl IA scribe la. Sistèm IA a trete epi konvèti mo ki pale yo an tèks, pou kontribye nan dosye medikal ou yo. Tanpri sonje ke AI scribe a pap pran okenn desizyon konsènan swen ou; terapet ou a ap revize tout nòt yo anvan li pran nenpòt desizyon.</p>
  
  <h4>Mezi Sekirite</h4>
  <p>Nou itilize mezi sekirite solid pou pwoteje konfidansyalite ak entegrite enfòmasyon ki trete atravè lojisyèl AI Scribe la. Mezi sa yo gen ladann kriptaj, kontwòl aksè, ak odit sekirite regilye pou anpeche aksè san otorizasyon epi pwoteje done kont vyolasyon.</p>
  
  <h4>Dwa Pasyan yo</h4>
  <p>Tout dwa ki prevwa nan avi HIPPA nou an aplike pou AI scribe la.</p>
  
  <h4>Avantaj ak Risk pou itilize lojisyèl AI scribe la</h4>
  <h4>Avantaj</h4>
  <ul>
    <li>Amelyorasyon efikasite dokimantasyon dosye medikal</li>
    <li>Amelyorasyon presizyon nan transkripsyon enfòmasyon vèbal</li>
  </ul>
  <h4>Risk</h4>
  <ul>
    <li>Posibilite pou gen erè nan transkripsyon</li>
    <li>Limitasyon potansyèl nan rekonèt sèten aksan oswa modèl lapawòl</li>
  </ul>
  
  <h4>Konsantman Pasyan</h4>
  <p>Mwen li epi mwen konprann enfòmasyon ki nan fòm konsantman sa a. Mwen te gen posibilite pou m poze kesyon ki te jwenn repons ki te satisfezan pou mwen. Lè mwen siyen anba a, mwen bay konsantman mwen volontèman pou yo itilize lojisyèl AI scribe pou kreyasyon dosye medikal mwen yo nan CORA Physical Therapy.</p>
</div>`;
